/*
* @str 解析字符串
* @paragraphKindName 输出的paragraph名称 例如：paragraph0，beforeImgParagraph0...
* return: paragraph 和 paragraph的style
* */
import $ from '$'
function getParagraph(str,paragraphKindName,questionType) {
   str=fixAgreement(str,questionType)
   let result = replaceCommonJsonToTag(str),
        style = {style:{}},
        paragraph = {};
    let pattern =/#{(.+?)}#/g;
    let block = result.match(pattern);

    let index = 0;

    block && block.forEach(function (val) {
        let content = val.replace(/(#)/g, "");
        let obj = {}
        try{
            obj=JSON.parse(content);
        }catch (e){
            console.log(content)
        }
        switch (obj.type) {
            case 'para_begin':
                style['style'][`${paragraphKindName}${index}`] = obj.style;
                index++;
                break;
            default:
                break;
        }
    });

    let reg_stem = /#{"type":"para_begin"[^}]*}#(.*?)#{"type":"para_end"}#/ig;
    let firstRes = reg_stem.exec(result);
    if(!firstRes) return {};
    let p = firstRes[1].split(`#{"type":"P"}#`);
    firstRes[1] = p.map(function(val){
        if(!val){val = '<br/>'}
        return '<p class="'+ style['style'][`${paragraphKindName}0`] +'">'+val+'</p>';
    });
    paragraph[`${paragraphKindName}0`] = '<p class="'+ style['style'][`${paragraphKindName}0`] +'">'+firstRes[1].join("")+'</p>';
    let key = 0;
    while(reg_stem.lastIndex) {
        let pp = reg_stem.exec(result);
        if(!pp) break;
        key++;
        let p = pp[1].split(`#{"type":"P"}#`);
        pp[1] = p.map(function(val){
            if(!val){val = '<br/>'}
            return '<p class="'+ style['style'][`${paragraphKindName}${key}`] +'">'+val+'</p>';
        });
        pp[1] = pp[1].join('');
        paragraph[`${paragraphKindName}${key}`] = '<p class="'+ style['style'][`${paragraphKindName}${key}`] +'">'+pp[1]+'</p>';
    }
    style['style'] = JSON.stringify(style['style']);
    return {paragraph,style};
}
//部分题型协议修正
function fixAgreement(result,questionType){
	switch (questionType){
		case 'deliverySecond':
		//处理脱式二期错误协议
		//非公式开头不用过滤转义\
		if(result.match(/\\\\\\\\/g)||result.match(/\\\"/g)){
			result=result.replace(/\\"/g,'"').replace(/\\\\/g,"\\")
		}
   		result=result.replace('#{"type":"para_begin","style":"math_text"}##{"type":"delivery_equation","content":"','#{"type":"para_begin","style":"delivery_equation"}#')
		result=result.replace('","blank_list":[{"type":"blank","size":"delivery_blank","id":"1","class":"fillin"}]}','#{"type":"blank","size":"delivery_blank","id":"1","class":"fillin"}')		

			break;
		default:
			break;
	}
	return result
}


function getParagraphForEdit(str,paragraphKindName,questionType) {
	str=fixAgreement(str,questionType)
    let result = replaceCommonJsonToTag(str,'edit'),
        style = {style:{}},
        paragraph = {};

    let pattern =/#{(.+?)}#/g;
    let block = result.match(pattern);
    let index = 0;
    block && block.forEach(function (val) {
        let content = val.replace(/(#)/g, "");
        let obj = {};
        try{
            obj = JSON.parse(content);
        }catch (e){
            return;
        }
        switch (obj.type) {
            case 'para_begin':
                style['style'][`${paragraphKindName}${index}`] = obj.style;
                index++;
                break;
            default:
                break;
        }
    });

    let reg_stem = /#{"type":"para_begin"[^}]*}#([\s\S]*?)#{"type":"para_end"}#/ig;
    let firstRes = reg_stem.exec(result);
    if(!firstRes) return {};
    let p = firstRes[1].split(`#{"type":"P"}#`);
    firstRes[1] = p.map(function(val){
        if(!val){val = '<br/>'}
        return '<p>'+val+'</p>';
    });

    paragraph[`${paragraphKindName}0`] = firstRes[1].join("");

    let key = 0;
    while(reg_stem.lastIndex) {
        let pp = reg_stem.exec(result);
        if(!pp) break;
        key++;
        let p = pp[1].split(`#{"type":"P"}#`);
        pp[1] = p.map(function(val){
            if(!val){val = '<br/>'}

            return '<p>'+val+'</p>';
        });

        paragraph[`${paragraphKindName}${key}`] = pp[1].join('');
    }
	

    style['style'] = JSON.stringify(style['style']);
    return {paragraph,style};
}
/*
* 替换 #{...}# 包围的样式种类
*
* */
function replaceCommonJsonToTag (str,edit) {
    if(!str)return '';
    str = str.replace(/</g,'&lt;');
    str = str.replace(/>/g,'&gt;');
    str = str.replace(/\n/g,'#{"type":"P"}#');
    str = str.replace(/\'/g,'&#39;');

    var result = str;

    result = result.replace(/}#([\s\S]*?)#{/g,function($,$1){
        return '}#'+$1.replace(/ /g,'&nbsp;')+'#{'
    });
    let pattern =/#{(.+?)}#/g;
    var block = result.match(pattern);
    block && block.forEach(function (val) {
        let content = val.replace(/(#)/g, "");
        let obj = {}
        try{
            obj = JSON.parse(content);
        }catch(error) {
            return ''
        }
        switch (obj.type) {
            case 'latex':
                let dot =/\\dot{([\S\s]*?)}/g;
                let isDot = dot.exec(obj.content);
                if(isDot){//小数点的情况
                    let content = obj.content.replace(isDot[0],`<span class="question-dot">${isDot[1]}</span>`);//兼容content为"35.\\dot{5}"的情况
                    result = result.replace(val,content);
                    break
                }
                //解析上划线
                let overlineReg =/\\overline{([\S\s]*?)}/g;
                let isOverline = overlineReg.exec(obj.content);
                if(isOverline){
                    let content = obj.content.replace(isOverline[0],`<span style="text-decoration:overline" class="question-overline">${isOverline[1]}</span>`);//兼容content为"35.\\dot{5}"的情况
                    result = result.replace(val,content);
                    break
                }

                let pattern1 =/{"type":"blank".*?}\\/g;
                var block1 = obj.content.match(pattern1);
                block1&&block1.forEach((val)=>{
                    obj.content = obj.content.replace(val,`left[\\right]`);
                })
//              console.log("result",result,val)
                result = result.replace(val,`<span class="mathquill-embedded-latex">${obj.content}</span>`);
                break;
             case 'delivery_equation':
                let latexContent = obj.content;
                const opReg = /\+|-|\/|\*|＋|÷|×/;
                let newLatexContent = "";
                const latexArray = latexContent.split(opReg)
                latexArray.forEach(v => {
                    // Latex数据如果是json格式，且左右含有[]()1等特殊字符，需要去除
                    let formulaWithoutBrancket = v;
                    let jsonData = v.match(/{.*}/g);
                    if(jsonData && jsonData.length > 0) {
                        formulaWithoutBrancket = jsonData[0];
                    }
                    let latexData = formulaWithoutBrancket;
                    if(isJSON(formulaWithoutBrancket)) {
                        latexData = JSON.parse(formulaWithoutBrancket);
                        latexData = `<span class="mathquill-embedded-latex">${latexData.content}</span>`;
                    }
                    newLatexContent = latexContent.replace(formulaWithoutBrancket, latexData);
                    latexContent = newLatexContent;
                });
                block[index] = newLatexContent;
                break;
            case 'blank':
                switch (obj.size){
                    case 'express':
                        result = result.replace(val,`<img src="./static/img/edu_fillin_express.png" class="img_fillin_express"/>`);
                        break;
                    case 'letter':
                        result = result.replace(val,`<img src="./static/img/edu_fillin_word.png" class="img_fillin_letter"/>`);
                        break;
                    case 'equation':
                        result = result.replace(val,`<img src="./static/img/fillin_equation.png" class="img_fillin_equation"/>`);
                        break;
                   	case 'delivery_blank':
                        result = result.replace(val,`<img src="./static/img/fillin_delivery.png" class="img_fillin_delivery"/>`);
                        break;
                    case 'line':
                        result = result.replace(val,`<img src="./static/img/edu_fillin_line.png" class="img_fillin_line"/>`);
                        break;
                    case 'multiline':
                        result = result.replace(val,`<img src="./static/img/edu_fillin_multiline.png" class="img_fillin_multiline"/>`);
                        break;
                    case 'fillin':
                        result = result.replace(val,`blank`);
                        break;
                    default:
                        break;
                };
                break;
            case 'img':
                switch (obj.size){
                    case 'small_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_smaller_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'mid_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_middle_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'big_image':
                    		if(obj.src){
                    			result = result.replace(val, `<img src="${obj.src}" class="mis_bigger_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                    		}else{
                    			result = result.replace(val, ``);
                    		}
                        
                        break;
                    case 'order_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_order_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'choice_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_bigger_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'small_category_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_smaller_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'big_category_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_bigger_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'small_match_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_smaller_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    case 'big_match_image':
                        result = result.replace(val, `<img src="${obj.src}" class="mis_bigger_image" width="${'px'+obj.width}" height="${'px'+obj.height}"/>`);
                        break;
                    default:
                        break;
                };
                break;
            case 'audio':
                switch (obj.style){
                    case 'math_reading':
                        if(edit){
                            result = result.replace(val,`<audio class="math_reading" src="${obj.src}"  controls="controls">您的浏览器不支持</audio>&nbsp;&nbsp;`);
                        }else{
                            result = result.replace(val,`<div style="margin-bottom: 10px"><div class="inner_audio"}></div><span>点击读题</span><audio class="math_reading" src="${obj.src}" style="display:none"></audio></div>`);
                        }
                        break;
                    default:
                    		if(obj.src.length){
                    			result = result.replace(val,`<audio src="${obj.src}" controls="controls">您的浏览器不支持</audio>&nbsp;&nbsp;`);
                    		}else{
                    			result = result.replace(val,'');
                    		}
                    		
                        break;
                };
                break;
            case 'guide_audio':
                result = obj.src?result.replace(val,`<audio src="${obj.src}" controls="controls">您的浏览器不支持</audio>&nbsp;&nbsp;`):result.replace(val,``);
                break;

            case 'operation_fix_drag':
                    var con = `<div><img style='display: block;' src='${obj.backgroup_url}' width='${obj.backgroup_size[0]}' height='${ obj.backgroup_size[1] }' />`;
                    obj.drag_list.forEach(item => {
                        con += `<span style='position: absolute;display: block;border:1px solid gray;left: ${item.position[0]}px; top: ${item.position[1]}px;width:${item.size[0]}px;height:${item.size[1]}px;'></span>`;  
                    });
                    obj.item_list.forEach(item => {
                        con += `<img style='position: absolute; left: ${item.position[0]}px; top: ${item.position[1]}px;' src='${item.image_url}' width='${item.size[0]}' height='${item.size[1]}' />`;  
                    });
                    con += `</div>`;
                    result = result.replace(val, con);
                    break;
            case 'operation_clean':
                const images = obj.image_url_list;
                var con = `<div style='position: relative;'><img style='display: block;' src='${obj.backgroup_url}' width='${obj.backgroup_size[0]}' height='${obj.backgroup_size[1]}' />`;
                obj.image_list.forEach(item => {
                    const img = images.find(val => val.id == item.image_url_id);
                    con += `<img style='position: absolute; left: ${item.position[0]}px; top: ${ item.position[1]}px;' src='${img.image_url}' width='${item.size[0]}' height='${item.size[1]   }' />`;                 
                });
                con += `</div>`;
                result = result.replace(val, con);
                break;
            case 'operation_unfix_drag':
                var con = `<div style='position: relative;'><img style='display: block;' src='${obj.backgroup_url}' width='${obj.backgroup_size[0]}' height='${obj.backgroup_size[1]}' />`;
                obj.enable_move_element.forEach(item => {
                    con += `<img style='position: absolute; left: ${item.position[0]}px; top: ${item.position[1]}px;' src='${item.image_url}' width='${item.size[0]}' height='${item.size[1]}' />`;
                });
                con += `</div>`;
                result = result.replace(val, con);
                break;
            default:
                break;
        }

    });
    result = result.replace(/#{"type":"under_begin"}#/g,'<u>').replace(/#{"type":"under_end"}#/g,'</u>');

    result = result.replace(/[\W\w](&nbsp;)[\W\w]/ig,function($,$1){
        if($[0]!==';'&&$[$.length-1]!=='&'){

            return $.replace(/&nbsp;/g,' ')
        }else{
            return $
        }
    });
    return result;
}



/*
* 解析的解析
*
* */
function getExplain(str) {
    if(!str||str.length < 1){
        return '';
    }
    str = str.replace(/\s/g,'&nbsp;');
    var result = replaceCommonJsonToTag(str);
    var block = result.split(`#{"type":"P"}#`);
    let explain = block.map(function(val){
        return `<p>${val}</p>`;
    });
    return explain.join('');
}
/*
* 核心解析
*
* */
function getCore(str){
    if(str.length < 2){
        return '';
    }
    var result = replaceCommonJsonToTag(str);
    var block = result.split(`#{"type":"P"}#`);
    let core = block.map(function(val){
        return `<p>${val}</p>`;
    });
    return core.join('');
}
function isJSON(str) {
    try {
        var obj = JSON.parse(str);
        return !!obj && (typeof obj === 'undefined' ? 'undefined' : typeof obj) === 'object';
    } catch (e) {/* ignore */}
    return false;
}

export {replaceCommonJsonToTag,getExplain,getCore,getParagraph,getParagraphForEdit}


// WEBPACK FOOTER //
// ./src/utils/createRender.js